import { addEmploymentType } from "../../../../../actions/Utilities/EmploymentType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useAddEmploymentType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (employmentTypeNewData) => addEmploymentType(employmentTypeNewData),
    {
      onSuccess: (res) => {
        if (res == "Duplicate") {
          toast.fire(
            "Saving Failed",
            "Employment Type already exists!",
            "error"
          );
        } else {
          queryClient.invalidateQueries(["GetEmploymentType"]);
          toast.fire(
            "Success",
            "Employment Type Added Successfully",
            "success"
          );
        }
      },
      onError: () => {
        toast.fire("Failed", "Failed to Add Employment Type", "", "error");
      },
    }
  );

  return mutate;
};
export default useAddEmploymentType;
